import React, { FC, useCallback, useMemo } from 'react';
import { Route, Redirect } from 'react-router-dom';
import RouteWithSubRoutes from '../route_with_sub_routes/RouteWithSubRoutes';
import SubnavTabs from '../subnav_tabs/SubnavTabs';
import { connect } from 'react-redux';
import { nullSafeGet } from '../../utils/DataAccessUtils';
import { authorizedRolesCombinations, checkAuthorization } from '../roles/roles';
import { isUserManagedBySupplier } from '../../utils/AuthUtils';

require('./BuyerAdminPage.less');

const BuyerAdminPage: FC<any> = ({ childRoutes, history, companyConfig, currentUser }) => {
	const handleTabChange = useCallback((key) => history.push(`/buyer/admin/${key}`), [history]);

	const checkTabActive = useCallback(
		(key) => {
			const pathname = history.location.pathname;
			return pathname.indexOf(key) !== -1;
		},
		[history.location.pathname]
	);

	const isNotSupplierManaged = useMemo(() => !isUserManagedBySupplier(currentUser), [currentUser]);

	const tabs = useMemo(
		() => [
			{
				key: 'users',
				name: 'Users',
			},
			...(isNotSupplierManaged
				? [
						{
							key: 'companySettings',
							name: 'Settings',
						},
						{
							key: 'accessControl',
							name: 'Access Control',
						},
						{
							key: 'resolutionTypes',
							name: 'Resolution Types',
						},
				  ]
				: []),
			...(checkAuthorization(authorizedRolesCombinations.SUPER_ADMIN_ONLY)(currentUser.roles)
				? [
						{
							key: 'impersonation',
							name: 'Impersonation',
						},
				  ]
				: []),
		],
		[currentUser.roles, isNotSupplierManaged]
	);

	return (
		<div>
			<Route
				path="/buyer/admin"
				exact={true}
				render={(props) => (
					<Redirect
						to={{
							pathname: '/buyer/admin/users',
						}}
					/>
				)}
			/>
			<div
				style={{
					padding: '24px',
					paddingBottom: 0,
					background: nullSafeGet('detail.config.theme.navblock', companyConfig),
					marginBottom: 8,
				}}
			>
				<h4
					style={{
						color: 'rgba(255, 255, 255, 0.9)',
						marginRight: 8,
						marginBottom: 24,
					}}
				>
					Admin
				</h4>
				<SubnavTabs tabs={tabs} onChange={handleTabChange} isActive={checkTabActive} />
			</div>
			{childRoutes.map((r, i) => (
				<RouteWithSubRoutes key={i} {...r} />
			))}
		</div>
	);
};

const mapStateToProps = (state) => ({
	companyConfig: state.company_config,
	currentUser: state.session.currentUser,
});

export default connect(mapStateToProps)(BuyerAdminPage);
